
                import "css-modules://src_components_cookie_cookie"
                export default {"Main":"_2db5e6","Visible":"_cd2803","Text":"_f412bd","Button":"_beadf1","Decline":"_9cb40b","Accept":"_9239ae"}
            